import React, { useState, useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "@/services/hooks";
// ACtions
import { saveSettingsRequired } from "@/services/templateServices/templateAction";
// Get All products
// Get All categories
// Get All ads
// Get All posts linked to the current blog
//get All Users
// select Input for template type
import Select from "react-select";
// Media selector
import ModelMediaContainer from "../../Media/ModelMediaContainer";
import VariableField from "../../variableFields/VariableField";
import { useVariableOptions } from "../../variableFields/useVariableOptions";

// reactstrap components
import {
  Col,
  Label,
  FormGroup,
  InputGroup,
  InputGroupText,
  Input,
  Row,
  Form,
} from "reactstrap";
// nodejs library that concatenates classes

// SCRUM-1404: a settings variable's stored `value` is a PER-SITE array,
// `[{ siteid, label }]`, holding one entry per tenant. The field components all
// expect a scalar, so without a translation React stringified the whole array
// into the input — every tenant saw `[object Object],[object Object],...` and
// could not read or edit their own value.
//
// The translation lives here, in the one host, and in both directions:
// narrow for display, rebuild on change. The field components stay unaware of
// the per-site shape, which is why StringField/LinkField are untouched.
//
// Rebuilding rather than sending the bare scalar is deliberate. The server
// accepts either (controllers/template.js:293-320), but only an array carries
// the OTHER tenants' entries, and an untouched variable must still post them:
// sending a scalar for one variable and the raw array for the rest is exactly
// what made a partial save write `label: ''` over every variable the editor had
// not opened.

/** Is this the per-site `[{ siteid, label }]` shape, or a plain value? */
const isPerSiteValue = (value) =>
  Array.isArray(value) &&
  value.length > 0 &&
  value.every((entry) => entry && typeof entry === "object" && "siteid" in entry);

/**
 * The value this site should see. A non-per-site value passes through
 * untouched — `reviewer` stores an array of user ids and must not be narrowed.
 *
 * With no site context the value ALSO passes through untouched, rather than
 * being blanked. Narrowing needs a site to narrow to, and blanking instead would
 * change behaviour in a state this screen never reaches in the app while
 * breaking what does depend on it: `ServiceField` unwraps the per-site shape
 * itself, pinned by "service: unwraps the per-site DB format ... (quirk)" in
 * settingsVariables.types.test.jsx, whose harness supplies no site. So this
 * function only ever ADDS correctness when a site is known.
 */
const valueForSite = (value, siteId) => {
  if (!isPerSiteValue(value)) return value;
  if (!siteId) return value;
  const entry = value.find((v) => String(v.siteid) === siteId);
  return entry ? entry.label : "";
};

/**
 * Put an edited scalar back as this site's entry, leaving every other tenant's
 * entry byte-identical. With no site context we cannot address an entry, so the
 * scalar is passed through and the server falls back to its own header site.
 */
const valueWithSite = (previous, next, siteId) => {
  if (!siteId) return next;
  const base = isPerSiteValue(previous) ? previous : [];
  const idx = base.findIndex((v) => String(v.siteid) === siteId);
  if (idx === -1) return [...base, { siteid: siteId, label: next }];
  return base.map((entry, i) => (i === idx ? { ...entry, label: next } : entry));
};

function HandleRequired() {
  const dispatch = useAppDispatch();

  const settingsRequired = useAppSelector(
    (state) => state.templates.settings_required
  );

  const currentSite = useAppSelector((state) => state.sites.site);
  const siteId = currentSite && currentSite._id ? String(currentSite._id) : null;

  // All settings variables of this bucket (local copy of the redux slice)
  const [Variables, setVariables] = useState<any[]>([]); // any: copies templates.settings_required, typed any[] there (templateSlice.ts:26)
  // shared option lists for the entity building blocks (SCRUM-554)
  const variableOptions = useVariableOptions();

  useEffect(() => {
    // match local state to redux state to be able to handle it
    setVariables(settingsRequired);
  }, [settingsRequired]);














  // Handle change of Boolean 
  const onChangeValueDropDown = (e, action) => {
    let targetVariable: (typeof Variables)[number] = {};
    // Get the variable that we want to change its value by the name
    targetVariable = Variables.filter(
      (settingVar) => settingVar.variable === action.name
    )[0];
    // SCRUM-1404: write the choice back as THIS site's entry, not over the
    // whole per-site array.
    const rebuilt = {
      ...targetVariable,
      value: valueWithSite(targetVariable.value, e.value, siteId),
    };

    const updated = [...Variables].map((settingVar) =>
      settingVar.variable === action.name ? rebuilt : settingVar
    );

    // apply changes to the state
    setVariables(updated);

    // Save the new variables into redux
    dispatch(saveSettingsRequired(updated));

  };









  // VariableField building blocks (SCRUM-551) report (name, value);
  // persist exactly like the legacy handlers: update local state and
  // save the full variables list to redux.
  const applyFieldValue = (name, value) => {
    // SCRUM-1404: `value` is this site's scalar; rebuild the per-site array so
    // the other tenants' entries survive the save.
    const updated = Variables.map((settingVar) =>
      settingVar.variable === name
        ? { ...settingVar, value: valueWithSite(settingVar.value, value, siteId) }
        : settingVar
    );
    setVariables(updated);
    dispatch(saveSettingsRequired(updated));
  };


  if (Variables.length > 0) {
    return (
      <div>
        {Variables.map((storedVar) => {
          // SCRUM-1404: everything below renders THIS site's value. The stored
          // per-site array stays in `Variables` untouched, so a save can rebuild
          // it with the other tenants intact.
          const settingVar = {
            ...storedVar,
            value: valueForSite(storedVar.value, siteId),
          };

          // Case String => simple input
          if (settingVar.type === "String") {
              if (settingVar.variable === 'reviewer') {
              return(
                <div key={storedVar.variable}>
                <Row>
                  {/* LABEL FOR VARIABLE NAME  */}
                  <Label
                    className="form-control-label"
                    htmlFor="example-text-input"
                    md="3"
                  >
                    {settingVar.variable}
                  </Label>
                  {/* INPUT FOR VARIABLE VALUE  */}
                  <Col md="9">
                  <Select
                      value={
                        Array.isArray(settingVar.value) && settingVar.value.length > 0
                          ? variableOptions.users.filter(option =>
                              settingVar.value.includes(option.value)
                            )
                          : variableOptions.users.find(option => option.value === settingVar.value) || null
                      }
                      name={settingVar.variable}
                      options={variableOptions.users}
                      onChange={onChangeValueDropDown}
                      isSearchable={true}
                    />
                  </Col>
                </Row>
              </div>
              )
            }
            // Case logo/option => Cloudinary image picker instead of text input
            if (settingVar.variable === 'logo' || settingVar.variable === 'option') {
              const onImageSelect = (selectedImage) => {
                if (selectedImage && selectedImage.secure_url) {
                  applyFieldValue(settingVar.variable, selectedImage.secure_url);
                }
              };

              return (
                <div key={storedVar.variable} className="mb-3">
                  <Row>
                    <Label className="form-control-label" md="3">
                      {settingVar.variable}
                    </Label>
                    <Col md="3">
                      <ModelMediaContainer selectedImg={onImageSelect} />
                    </Col>
                    <Col md="6">
                      {settingVar.value && (
                        <img
                          src={settingVar.value}
                          alt={settingVar.variable}
                          style={{ maxWidth: '100%', maxHeight: 80, objectFit: 'cover', borderRadius: 6 }}
                        />
                      )}
                    </Col>
                  </Row>
                </div>
              );
            }
          }


          // Every registry type renders through the VariableField dispatcher
          // (SCRUM-551/552/553); unknown types render nothing, exactly like the
          // legacy fall-through. Entity types get their options injected here.
          return (
            <VariableField
              key={storedVar.variable}
              settingVar={settingVar}
              options={variableOptions[settingVar.type]}
              onChange={applyFieldValue}
            />
          );
        })}
      </div>
    );
  } else if (Variables.length === 0) {
    return <div>No Required settings variables available...</div>;
  } else {
    return <div>Error try again...</div>;
  }
}

export default HandleRequired;
